// a function that gets portalidentifier from PortalApiContext

import { useContext } from "react";
import { PortalIdContext } from "./PortalApiProvider";

export const usePortalIdentifier = () => {
  const data = useContext(PortalIdContext);
  return data.portalIdentifier;
};
